import { render } from "./PersonalComponent.vue?vue&type=template&id=9e2726fa&scoped=true"
import script from "./PersonalComponent.vue?vue&type=script&lang=js"
export * from "./PersonalComponent.vue?vue&type=script&lang=js"

import "./PersonalComponent.vue?vue&type=style&index=0&id=9e2726fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2726fa"]])

export default __exports__